import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { PaymentImportService } from '../services/payment-import.service';
import { PaymentImport } from '../../dto/payment-import';
import { MultiCrudDataSource } from '../../table-datasouces/multi-crud.datasource';
import { MatTableGeneratorComponent } from '../../shared/mat-table-generator/mat-table-generator.component';
import { FileImportDialogComponent } from '../../shared/file-import-dialog/file-import-dialog.component';
import {MatDialog} from '@angular/material/dialog';

/**
 * Provide functionality to showing uploaded earlier payments
 * and to import new files with payment,
 * evry row in this view is one imported file
 */
@Component({
  selector: 'app-payment-import',
  templateUrl: './payment-import.component.html',
  styleUrls: ['./payment-import.component.css']
})
export class PaymentImportComponent implements OnInit {

  dataSource = new MultiCrudDataSource(this.importService);

  @ViewChild(MatTableGeneratorComponent, { static: true }) table: MatTableGeneratorComponent;

  isLoading = false;

  constructor(
    private importService: PaymentImportService,
    private datePipe: DatePipe,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  importsCols = [
    { columnDef: 'id', header: 'id', cell: (row: PaymentImport) => `${row.id}` },
    { columnDef: 'date', header: 'Date', cell: (row: PaymentImport) => `${this.datePipe.transform(row.date, 'dd.MM.yyyy')}` },
    { columnDef: 'userId', header: 'User', cell: (row: PaymentImport) => `${row.username}` },
    { columnDef: 'ipAddress',       header: 'Ip address', cell: (row: PaymentImport) => `${row.ipAddress}`},
    { columnDef: 'totalRowCount', header: 'Total rows', cell: (row: PaymentImport) => `${row.totalRowCount}` },
    { columnDef: 'invalidRowCount', header: 'Invalid rows', cell: (row: PaymentImport) => `${row.invalidRowCount}` },
  ];

  ngOnInit() {
  }

  /**
   * Upload file to server, process result,
   * after upload show modal dialog, whare user can go over
   * imported payments
   *
   * @param file file for upload
   */
  onUpload(file) {
    this.isLoading = true;
    this.importService.upload(file)
      .subscribe(result => {
          this.isLoading = false;
        this.dataSource.data.push(result);
        this.table.refreshTable();

        this.dialog.open(FileImportDialogComponent, {
          data: {
            import: result,
            link: this.router.url + '/' + result.id.toString()
          },
          maxWidth: 400,
        });
      },
      err => {
        this.isLoading = false;
      });
  }

  gotoImport(id: number) {
    this.router.navigate([id], { relativeTo: this.route });
  }

  getRowClass = (item: PaymentImport): string => item.invalidRowCount > 0 ? 'warning-row' : '';

  getViewLink = (item: PaymentImport): string => item.id.toString();
}
